import React from "react";

// LoadingSpinner.jsx
export function LoadingSpinner({ message, small = false }) {
  return (
    <div className="flex items-center justify-center p-4">
      <div
        className={`animate-spin rounded-full ${
          small ? "h-4 w-4" : "h-8 w-8"
        } border-b-2 border-gray-900`}
      ></div>
      <p className={`ml-2 ${small ? "text-sm" : ""} text-gray-600`}>
        {message}
      </p>
    </div>
  );
}

// ErrorMessage.jsx
export function ErrorMessage({ message }) {
  return (
    <div className="container mx-auto p-4">
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        {message}
      </div>
    </div>
  );
}

// NotFoundMessage.jsx

export function NotFoundMessage({ message }) {
  return (
    <div className="container mx-auto p-4 mb-10 md:mb-48">
      <p className="text-gray-600">{message}</p>
    </div>
  );
}

// PaginationControls.jsx
export function PaginationControls({ page, setPage, hasNextPage, isLoading }) {
  return (
    <div className="flex justify-center gap-2">
      <button
        onClick={() => setPage((old) => Math.max(old - 1, 1))}
        disabled={page === 1 || isLoading}
        className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300 transition-colors"
      >
        Anterior
      </button>
      <span className="px-4 py-2 bg-gray-100 rounded flex items-center">
        {isLoading ? (
          <span className="animate-pulse">Carregando...</span>
        ) : (
          `Página ${page}`
        )}
      </span>
      <button
        onClick={() => !isLoading && setPage((old) => old + 1)}
        disabled={!hasNextPage || isLoading}
        className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300 transition-colors"
      >
        Próxima
      </button>
    </div>
  );
}
